// Code generated by the Encore v1.48.12 client generator. DO NOT EDIT.

// Disable eslint, jshint, and jslint for this file.
/* eslint-disable */
/* jshint ignore:start */
/*jslint-disable*/

/**
 * BaseURL is the base URL for calling the Encore application's API.
 */
export type BaseURL = string

export const Local: BaseURL = "http://localhost:4000"

/**
 * Environment returns a BaseURL for calling the cloud environment with the given name.
 */
export function Environment(name: string): BaseURL {
    return `https://${name}-ledgentic-backend-bvdi.encr.app`
}

/**
 * PreviewEnv returns a BaseURL for calling the preview environment with the given PR number.
 */
export function PreviewEnv(pr: number | string): BaseURL {
    return Environment(`pr${pr}`)
}

const BROWSER = typeof globalThis === "object" && ("window" in globalThis);

/**
 * Client is an API client for the ledgentic-backend-bvdi Encore application.
 */
export default class Client {
    public readonly chart_of_accounts: chart_of_accounts.ServiceClient
    public readonly fiscal_periods: fiscal_periods.ServiceClient
    public readonly agent_accounts_payable: agent_accounts_payable.ServiceClient
    public readonly api_gateway: api_gateway.ServiceClient
    public readonly evals: evals.ServiceClient
    public readonly fortnox: fortnox.ServiceClient
    public readonly invoices: invoices.ServiceClient
    public readonly public_api_gateway: public_api_gateway.ServiceClient
    private readonly options: ClientOptions
    private readonly target: string


    /**
     * Creates a Client for calling the public and authenticated APIs of your Encore application.
     *
     * @param target  The target which the client should be configured to use. See Local and Environment for options.
     * @param options Options for the client
     */
    constructor(target: BaseURL, options?: ClientOptions) {
        this.target = target
        this.options = options ?? {}
        const base = new BaseClient(this.target, this.options)
        this.chart_of_accounts = new chart_of_accounts.ServiceClient(base)
        this.fiscal_periods = new fiscal_periods.ServiceClient(base)
        this.agent_accounts_payable = new agent_accounts_payable.ServiceClient(base)
        this.api_gateway = new api_gateway.ServiceClient(base)
        this.evals = new evals.ServiceClient(base)
        this.fortnox = new fortnox.ServiceClient(base)
        this.invoices = new invoices.ServiceClient(base)
        this.public_api_gateway = new public_api_gateway.ServiceClient(base)
    }

    /**
     * Creates a new Encore client with the given client options set.
     *
     * @param options Client options to set. They are merged with existing options.
     **/
    public with(options: ClientOptions): Client {
        return new Client(this.target, {
            ...this.options,
            ...options,
        })
    }
}

/**
 * ClientOptions allows you to override any default behaviour within the generated Encore client.
 */
export interface ClientOptions {
    /**
     * By default the client will use the inbuilt fetch function for making the API requests.
     * however you can override it with your own implementation here if you want to run custom
     * code on each API request made or response received.
     */
    fetcher?: Fetcher

    /** Default RequestInit to be used for the client */
    requestInit?: Omit<RequestInit, "headers"> & { headers?: Record<string, string> }

    /**
     * Allows you to set the authentication data to be used for each
     * request either by passing in a static object or by passing in
     * a function which returns a new object for each request.
     */
    auth?: api_gateway.AuthParams | AuthDataGenerator
}

export namespace chart_of_accounts {

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.bootstrapOrganizationAccounts = this.bootstrapOrganizationAccounts.bind(this)
            this.createAccount = this.createAccount.bind(this)
            this.deleteAccount = this.deleteAccount.bind(this)
            this.getAccount = this.getAccount.bind(this)
            this.getAccountClass = this.getAccountClass.bind(this)
            this.getAccountClasses = this.getAccountClasses.bind(this)
            this.getAccountDescendants = this.getAccountDescendants.bind(this)
            this.getAccountHierarchy = this.getAccountHierarchy.bind(this)
            this.getAccountPath = this.getAccountPath.bind(this)
            this.getChartOfAccounts = this.getChartOfAccounts.bind(this)
            this.listAccounts = this.listAccounts.bind(this)
            this.seedAccounts = this.seedAccounts.bind(this)
            this.updateAccount = this.updateAccount.bind(this)
        }

        public async bootstrapOrganizationAccounts(organizationId: string, params: {
    country?: string
}): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/organizations/${encodeURIComponent(organizationId)}/bootstrap-accounts`, JSON.stringify(params))
        }

        public async createAccount(params: types.CreateAccountPayload): Promise<types.AccountWithClass> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/accounts`, JSON.stringify(params))
            return await resp.json() as types.AccountWithClass
        }

        public async deleteAccount(id: string): Promise<{
    success: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("DELETE", `/accounts/${encodeURIComponent(id)}`)
            return await resp.json() as {
    success: boolean
}
        }

        public async getAccount(id: string): Promise<types.AccountWithClass> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/accounts/${encodeURIComponent(id)}`)
            return await resp.json() as types.AccountWithClass
        }

        public async getAccountClass(id: string): Promise<types.AccountClass> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/account-classes/${encodeURIComponent(id)}`)
            return await resp.json() as types.AccountClass
        }

        public async getAccountClasses(): Promise<{
    accountClasses: types.AccountClass[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/account-classes`)
            return await resp.json() as {
    accountClasses: types.AccountClass[]
}
        }

        public async getAccountDescendants(id: string, params: {
    includeInactive?: boolean
}): Promise<{
    descendants: types.Account[]
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                includeInactive: params.includeInactive === undefined ? undefined : String(params.includeInactive),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/accounts/${encodeURIComponent(id)}/descendants`, undefined, {query})
            return await resp.json() as {
    descendants: types.Account[]
}
        }

        public async getAccountHierarchy(id: string): Promise<types.AccountWithHierarchy> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/accounts/${encodeURIComponent(id)}/hierarchy`)
            return await resp.json() as types.AccountWithHierarchy
        }

        public async getAccountPath(id: string): Promise<{
    path: types.Account[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/accounts/${encodeURIComponent(id)}/path`)
            return await resp.json() as {
    path: types.Account[]
}
        }

        public async getChartOfAccounts(organizationId: string): Promise<{
    accounts: routes.AccountHierarchyRow[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/organizations/${encodeURIComponent(organizationId)}/chart-of-accounts`)
            return await resp.json() as {
    accounts: routes.AccountHierarchyRow[]
}
        }

        public async listAccounts(organizationId: string, params: types.ListAccountsPayload): Promise<{
    accounts: types.AccountWithClass[] | types.AccountWithHierarchy[]
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                accountClassId:   params.accountClassId,
                includeHierarchy: params.includeHierarchy === undefined ? undefined : String(params.includeHierarchy),
                isActive:         params.isActive === undefined ? undefined : String(params.isActive),
                parentId:         params.parentId === undefined ? undefined : String(params.parentId),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/organizations/${encodeURIComponent(organizationId)}/accounts`, undefined, {query})
            return await resp.json() as {
    accounts: types.AccountWithClass[] | types.AccountWithHierarchy[]
}
        }

        public async seedAccounts(organizationId: string, params: types.SeedAccountsPayload): Promise<types.SeedAccountsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/organizations/${encodeURIComponent(organizationId)}/seed-accounts`, JSON.stringify(params))
            return await resp.json() as types.SeedAccountsResponse
        }

        public async updateAccount(id: string, params: {
    name?: string
    description?: string
    parentId?: string | null
    isActive?: boolean
    isBankAccount?: boolean
    allowManualJournal?: boolean
    defaultVatCode?: string | null
    defaultVatRate?: number | null
}): Promise<types.AccountWithClass> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/accounts/${encodeURIComponent(id)}`, JSON.stringify(params))
            return await resp.json() as types.AccountWithClass
        }
    }
}

export namespace fiscal_periods {

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.bootstrapOrganization = this.bootstrapOrganization.bind(this)
            this.createAccountingPeriod = this.createAccountingPeriod.bind(this)
            this.createFiscalYear = this.createFiscalYear.bind(this)
            this.generateMonthlyPeriods = this.generateMonthlyPeriods.bind(this)
            this.getAccountingPeriods = this.getAccountingPeriods.bind(this)
            this.getCurrentPeriod = this.getCurrentPeriod.bind(this)
            this.getFiscalYear = this.getFiscalYear.bind(this)
            this.getFiscalYears = this.getFiscalYears.bind(this)
            this.updateAccountingPeriod = this.updateAccountingPeriod.bind(this)
            this.updateFiscalYear = this.updateFiscalYear.bind(this)
        }

        public async bootstrapOrganization(orgId: string): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/organizations/${encodeURIComponent(orgId)}/bootstrap`)
        }

        public async createAccountingPeriod(params: types.CreateAccountingPeriodPayload): Promise<types.AccountingPeriod> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/accounting-periods`, JSON.stringify(params))
            return await resp.json() as types.AccountingPeriod
        }

        public async createFiscalYear(params: types.CreateFiscalYearPayload): Promise<types.FiscalYear> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/fiscal-years`, JSON.stringify(params))
            return await resp.json() as types.FiscalYear
        }

        public async generateMonthlyPeriods(fiscalYearId: string): Promise<{
    periods: types.AccountingPeriod[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/fiscal-years/${encodeURIComponent(fiscalYearId)}/generate-periods`)
            return await resp.json() as {
    periods: types.AccountingPeriod[]
}
        }

        public async getAccountingPeriods(fiscalYearId: string): Promise<{
    periods: types.AccountingPeriod[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/fiscal-years/${encodeURIComponent(fiscalYearId)}/periods`)
            return await resp.json() as {
    periods: types.AccountingPeriod[]
}
        }

        public async getCurrentPeriod(organizationId: string): Promise<{
    period: types.AccountingPeriod | null
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/organizations/${encodeURIComponent(organizationId)}/current-period`)
            return await resp.json() as {
    period: types.AccountingPeriod | null
}
        }

        public async getFiscalYear(id: string): Promise<types.FiscalYear> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/fiscal-years/${encodeURIComponent(id)}`)
            return await resp.json() as types.FiscalYear
        }

        public async getFiscalYears(organizationId: string): Promise<{
    fiscalYears: types.FiscalYear[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/organizations/${encodeURIComponent(organizationId)}/fiscal-years`)
            return await resp.json() as {
    fiscalYears: types.FiscalYear[]
}
        }

        public async updateAccountingPeriod(id: string, params: {
    name?: string
    status?: types.AccountingPeriodStatus
}): Promise<types.AccountingPeriod> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/accounting-periods/${encodeURIComponent(id)}`, JSON.stringify(params))
            return await resp.json() as types.AccountingPeriod
        }

        public async updateFiscalYear(id: string, params: {
    name?: string
    status?: types.FiscalYearStatus
}): Promise<types.FiscalYear> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/fiscal-years/${encodeURIComponent(id)}`, JSON.stringify(params))
            return await resp.json() as types.FiscalYear
        }
    }
}

export namespace agent_accounts_payable {

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.accountLineItemsTaskHandler = this.accountLineItemsTaskHandler.bind(this)
            this.sanityCheckInvoice = this.sanityCheckInvoice.bind(this)
        }

        /**
         * Performs accounting on the line items of a given invoice
         */
        public async accountLineItemsTaskHandler(params: routes.ProcessInvoiceRequest): Promise<void> {
            // Convert our params into the objects we need for the request
            const headers = makeRecord<string, string>({
                authorization: params.apiKey,
            })

            // Construct the body with only the fields which we want encoded within the body (excluding query string or header fields)
            const body: Record<string, any> = {
                invoiceId: params.invoiceId,
            }

            await this.baseClient.callTypedAPI("POST", `/accounting/invoice/line-items/process`, JSON.stringify(body), {headers})
        }

        public async sanityCheckInvoice(params: routes.SanityCheckInvoiceRequest): Promise<routes.SanityCheckInvoiceResponse> {
            // Convert our params into the objects we need for the request
            const headers = makeRecord<string, string>({
                authorization: params.apiKey,
            })

            // Construct the body with only the fields which we want encoded within the body (excluding query string or header fields)
            const body: Record<string, any> = {
                invoiceId: params.invoiceId,
            }

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/accounting/invoice/sanity-check`, JSON.stringify(body), {headers})
            return await resp.json() as routes.SanityCheckInvoiceResponse
        }
    }
}

export namespace api_gateway {
    export interface AuthParams {
        cookie?: string
        apiKey?: string
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.authenticationRouter = this.authenticationRouter.bind(this)
            this.bootstrapOrganization = this.bootstrapOrganization.bind(this)
            this.getAllInvoices = this.getAllInvoices.bind(this)
            this.getEvaluatedInvoices = this.getEvaluatedInvoices.bind(this)
            this.getEvaluationResults = this.getEvaluationResults.bind(this)
            this.getFullInvoiceData = this.getFullInvoiceData.bind(this)
            this.getInvoice = this.getInvoice.bind(this)
            this.getInvoices = this.getInvoices.bind(this)
            this.getOrganizationIdBySlug = this.getOrganizationIdBySlug.bind(this)
            this.getSpendingAnalytics = this.getSpendingAnalytics.bind(this)
            this.getSuppliers = this.getSuppliers.bind(this)
            this.health = this.health.bind(this)
        }

        public async authenticationRouter(method: "GET" | "POST" | "PATCH" | "PUT" | "DELETE" | "HEAD" | "OPTIONS" | "TRACE", _params: string[], body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/api/auth/${_params.map(encodeURIComponent).join("/")}`, body, options)
        }

        public async bootstrapOrganization(params: {
    orgId: string
}): Promise<{
    success: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/api/organization/bootstrap`, JSON.stringify(params))
            return await resp.json() as {
    success: boolean
}
        }

        public async getAllInvoices(params: {
    orgSlug: string
}): Promise<routes.GetAllInvoicesResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                orgSlug: params.orgSlug,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/api/invoice/all`, undefined, {query})
            return await resp.json() as routes.GetAllInvoicesResponse
        }

        public async getEvaluatedInvoices(): Promise<routes.EvalInvoicesListResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/admin/invoices/eval-invoices`)
            return await resp.json() as routes.EvalInvoicesListResponse
        }

        public async getEvaluationResults(): Promise<routes.GetEvaluationResultsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/admin/evals/results`)
            return await resp.json() as routes.GetEvaluationResultsResponse
        }

        public async getFullInvoiceData(invoiceId: string): Promise<routes.GetFullInvoiceDataResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/api/invoice/${encodeURIComponent(invoiceId)}/full-data`)
            return await resp.json() as routes.GetFullInvoiceDataResponse
        }

        /**
         * Get single invoice endpoint
         */
        public async getInvoice(id: string): Promise<types.InvoiceData> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/api/data/invoices/${encodeURIComponent(id)}`)
            return await resp.json() as types.InvoiceData
        }

        /**
         * Get invoices endpoint
         */
        public async getInvoices(params: types.InvoicesQueryParams): Promise<{
    data: types.InvoiceData[]
    total: number
    limit: number
    offset: number
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                dateFrom:   params.dateFrom,
                dateTo:     params.dateTo,
                limit:      params.limit === undefined ? undefined : String(params.limit),
                offset:     params.offset === undefined ? undefined : String(params.offset),
                search:     params.search,
                status:     params.status,
                supplierId: params.supplierId,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/api/data/invoices`, undefined, {query})
            return await resp.json() as {
    data: types.InvoiceData[]
    total: number
    limit: number
    offset: number
}
        }

        public async getOrganizationIdBySlug(orgSlug: string): Promise<{
    orgId: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/api/organization/${encodeURIComponent(orgSlug)}`)
            return await resp.json() as {
    orgId: string
}
        }

        /**
         * Get spending analytics endpoint
         */
        public async getSpendingAnalytics(params: {
    dateFrom?: string
    dateTo?: string
    groupBy?: "supplier" | "month"
}): Promise<types.SpendingAnalytics> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                dateFrom: params.dateFrom,
                dateTo:   params.dateTo,
                groupBy:  params.groupBy === undefined ? undefined : String(params.groupBy),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/api/data/spending-analytics`, undefined, {query})
            return await resp.json() as types.SpendingAnalytics
        }

        /**
         * Get suppliers endpoint
         */
        public async getSuppliers(): Promise<{
    data: types.SupplierData[]
    total: number
    limit: number
    offset: number
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/api/data/suppliers`)
            return await resp.json() as {
    data: types.SupplierData[]
    total: number
    limit: number
    offset: number
}
        }

        public async health(): Promise<void> {
            await this.baseClient.callTypedAPI("GET", `/health`)
        }
    }
}

export namespace evals {

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.getEvaluationResults = this.getEvaluationResults.bind(this)
            this.getGoldenInvoiceDataset = this.getGoldenInvoiceDataset.bind(this)
            this.runEval = this.runEval.bind(this)
            this.scheduleAllInvoicesForEval = this.scheduleAllInvoicesForEval.bind(this)
            this.triggerEvaluationAnalysis = this.triggerEvaluationAnalysis.bind(this)
        }

        public async getEvaluationResults(): Promise<routes.GetEvaluationResultsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/evals/results`)
            return await resp.json() as routes.GetEvaluationResultsResponse
        }

        public async getGoldenInvoiceDataset(): Promise<routes.GetGoldenInvoiceDatasetResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/evals/golden-data/invoices`)
            return await resp.json() as routes.GetGoldenInvoiceDatasetResponse
        }

        public async runEval(params: routes.RunEvalRequest): Promise<void> {
            // Convert our params into the objects we need for the request
            const headers = makeRecord<string, string>({
                authorization: params.apiKey,
            })

            // Construct the body with only the fields which we want encoded within the body (excluding query string or header fields)
            const body: Record<string, any> = {
                invoiceFileName: params.invoiceFileName,
            }

            await this.baseClient.callTypedAPI("POST", `/evals/run`, JSON.stringify(body), {headers})
        }

        public async scheduleAllInvoicesForEval(): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/evals/schedule-all`)
        }

        public async triggerEvaluationAnalysis(params: routes.TriggerEvaluationAnalysisRequest): Promise<{
    success: boolean
    message: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/evals/analysis/trigger`, JSON.stringify(params))
            return await resp.json() as {
    success: boolean
    message: string
}
        }
    }
}

export namespace fortnox {

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.getInvoices = this.getInvoices.bind(this)
        }

        public async getInvoices(): Promise<routes.GetFortnoxInvoicesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/fortnox/invoices`)
            return await resp.json() as routes.GetFortnoxInvoicesResponse
        }
    }
}

export namespace invoices {

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.getEvalInvoices = this.getEvalInvoices.bind(this)
            this.getInvoiceById = this.getInvoiceById.bind(this)
            this.getInvoiceStatus = this.getInvoiceStatus.bind(this)
            this.getInvoices = this.getInvoices.bind(this)
            this.getProcessedInvoicesPerDay = this.getProcessedInvoicesPerDay.bind(this)
            this.processInvoice = this.processInvoice.bind(this)
            this.runInvoiceOcr = this.runInvoiceOcr.bind(this)
            this.testWebhookReceiver = this.testWebhookReceiver.bind(this)
            this.updateLineItem = this.updateLineItem.bind(this)
            this.uploadEvalInvoice = this.uploadEvalInvoice.bind(this)
            this.uploadInvoiceFile = this.uploadInvoiceFile.bind(this)
        }

        public async getEvalInvoices(): Promise<routes.EvalInvoicesListResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/invoices/eval-invoices`)
            return await resp.json() as routes.EvalInvoicesListResponse
        }

        public async getInvoiceById(id: string): Promise<void> {
            await this.baseClient.callTypedAPI("GET", `/invoice/get/${encodeURIComponent(id)}`)
        }

        public async getInvoiceStatus(id: string): Promise<routes.GetInvoiceStatusResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/invoice/status/${encodeURIComponent(id)}`)
            return await resp.json() as routes.GetInvoiceStatusResponse
        }

        public async getInvoices(params: {
    orgSlug: string
}): Promise<routes.GetInvoicesResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                orgSlug: params.orgSlug,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/invoice/get`, undefined, {query})
            return await resp.json() as routes.GetInvoicesResponse
        }

        public async getProcessedInvoicesPerDay(params: {
    orgSlug: string
    days?: number
}): Promise<routes.ProcessedPerDayResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                days:    params.days === undefined ? undefined : String(params.days),
                orgSlug: params.orgSlug,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/invoice/processed-per-day`, undefined, {query})
            return await resp.json() as routes.ProcessedPerDayResponse
        }

        public async processInvoice(params: processors.ProcessInvoiceParams): Promise<void> {
            // Convert our params into the objects we need for the request
            const headers = makeRecord<string, string>({
                authorization: params.apiKey,
            })

            // Construct the body with only the fields which we want encoded within the body (excluding query string or header fields)
            const body: Record<string, any> = {
                invoiceId: params.invoiceId,
            }

            await this.baseClient.callTypedAPI("POST", `/invoice/tasks/process-invoice`, JSON.stringify(body), {headers})
        }

        public async runInvoiceOcr(id: string): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/invoice/ocr/${encodeURIComponent(id)}`)
        }

        public async testWebhookReceiver(method: "POST", body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/invoices/test/webhook-receiver`, body, options)
        }

        public async updateLineItem(lineItemId: string, params: routes.UpdateLineItemRequest): Promise<routes.UpdateLineItemResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/invoice/line-item/${encodeURIComponent(lineItemId)}/update`, JSON.stringify(params))
            return await resp.json() as routes.UpdateLineItemResponse
        }

        public async uploadEvalInvoice(params: routes.UploadEvalInvoiceRequest): Promise<routes.UploadEvalInvoiceResponse> {
            // Convert our params into the objects we need for the request
            const headers = makeRecord<string, string>({
                authorization: params.apiKey,
            })

            // Construct the body with only the fields which we want encoded within the body (excluding query string or header fields)
            const body: Record<string, any> = {
                base64File:            params.base64File,
                fileName:              params.fileName,
                goldenInvoiceFileName: params.goldenInvoiceFileName,
                isEvaluationInvoice:   params.isEvaluationInvoice,
                orgSlug:               params.orgSlug,
            }

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/invoices/eval-invoices/upload`, JSON.stringify(body), {headers})
            return await resp.json() as routes.UploadEvalInvoiceResponse
        }

        public async uploadInvoiceFile(params: routes.UploadInvoiceFileRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/invoice/upload`, JSON.stringify(params))
        }
    }
}

export namespace public_api_gateway {

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.deleteInvoice = this.deleteInvoice.bind(this)
            this.getInvoice = this.getInvoice.bind(this)
            this.getInvoiceStatus = this.getInvoiceStatus.bind(this)
            this.listInvoices = this.listInvoices.bind(this)
            this.submitInvoice = this.submitInvoice.bind(this)
            this.updateInvoice = this.updateInvoice.bind(this)
        }

        public async deleteInvoice(externalId: string): Promise<{
    success: boolean
    message: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("DELETE", `/public/v1/invoices/${encodeURIComponent(externalId)}`)
            return await resp.json() as {
    success: boolean
    message: string
}
        }

        public async getInvoice(externalId: string): Promise<types.FullSupplierInvoiceResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/public/v1/invoices/${encodeURIComponent(externalId)}`)
            return await resp.json() as types.FullSupplierInvoiceResponse
        }

        public async getInvoiceStatus(externalId: string): Promise<types.SupplierInvoiceStatusResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/public/v1/invoices/${encodeURIComponent(externalId)}/status`)
            return await resp.json() as types.SupplierInvoiceStatusResponse
        }

        public async listInvoices(params: types.ListSupplierInvoicesParams): Promise<types.ListSupplierInvoicesResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                createdDateFrom: params.createdDateFrom,
                createdDateTo:   params.createdDateTo,
                externalId:      params.externalId,
                fileName:        params.fileName,
                limit:           params.limit === undefined ? undefined : String(params.limit),
                page:            params.page === undefined ? undefined : String(params.page),
                sortBy:          params.sortBy === undefined ? undefined : String(params.sortBy),
                sortOrder:       params.sortOrder === undefined ? undefined : String(params.sortOrder),
                status:          params.status === undefined ? undefined : String(params.status),
                updatedDateFrom: params.updatedDateFrom,
                updatedDateTo:   params.updatedDateTo,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/public/v1/invoices`, undefined, {query})
            return await resp.json() as types.ListSupplierInvoicesResponse
        }

        public async submitInvoice(params: types.PublicSupplierInvoiceCreateRequest): Promise<types.PublicInvoiceCreateResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/public/v1/invoices`, JSON.stringify(params))
            return await resp.json() as types.PublicInvoiceCreateResponse
        }

        public async updateInvoice(externalId: string, params: {
    lineItems: types.UpdateInvoiceLineItemRequest[]
}): Promise<types.FullSupplierInvoiceResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PATCH", `/public/v1/invoices/${encodeURIComponent(externalId)}`, JSON.stringify(params))
            return await resp.json() as types.FullSupplierInvoiceResponse
        }
    }
}

export namespace client {
    export type InvoiceAnalysisStatus = "NOT_STARTED" | "OCR_PROCESSING" | "OCR_DONE" | "OCR_ERROR" | "ACCOUNTING_PROCESSING" | "ACCOUNTING_DONE" | "ACCOUNTING_ERROR" | "WAITING_FOR_HUMAN" | "SUCCESS" | "ERROR"
}

export namespace lib {
    export interface FortnoxInvoice {
        "@url": string
        Balance: number
        Booked: boolean
        Cancelled: boolean
        CostCenter: string
        Currency: string
        CurrencyRate: number
        CurrencyUnit: number
        CustomerName: string
        CustomerNumber: string
        DocumentNumber: string
        DueDate: string
        ExternalInvoiceReference1: string
        ExternalInvoiceReference2: string
        FinalPayDate: string
        InvoiceDate: string
        InvoiceType: "INVOICE" | "AGREEMENTINVOICE" | "INTRESTINVOICE" | "SUMMARYINVOICE" | "CASHINVOICE"
        NoxFinans: boolean
        OCR: string
        Project: string
        Sent: boolean
        TermsOfPayment: string
        Total: number
        VoucherNumber?: number
        VoucherSeries?: string
        VoucherYear?: number
        WayOfDelivery?: string
    }
}

export namespace processors {
    export interface ProcessInvoiceParams {
        invoiceId: string
        apiKey: string
    }
}

export namespace routes {
    export interface AccountHierarchyRow {
        path: string
        "account_number": string
        name: string
        description: string | null
        "account_class_name": string
        "account_type": string
    }

    export interface EvalInvoicesListResponse {
        data: GetEvalInvoicesResponse[]
    }

    export interface EvaluationResultResponseItem {
        id: string
        createdAt: string
        updatedAt: string
        invoiceId: string
        evaluationRunTimestamp: string
        processingVersionTag?: string | null
        overallAccuracyScore?: number | null
        invoiceNumberMatch?: boolean | null
        invoiceDateMatch?: boolean | null
        dueDateMatch?: boolean | null
        totalAmountMatch?: boolean | null
        totalAmountDiff?: number | null
        vatAmountMatch?: boolean | null
        vatAmountDiff?: number | null
        currencyMatch?: boolean | null
        supplierCompanyNameMatch?: boolean | null
        supplierOrgNumberMatch?: boolean | null
        lineItemsMatchedCount?: number | null
        lineItemsMissingCount?: number | null
        lineItemsExtraCount?: number | null
        lineItemAccuracyScore?: number | null
        lineItemAccountingScore?: number | null
        detailedFieldDiscrepancies?: any
        goldenInvoiceSnapshot?: any
    }

    export interface GetAllInvoicesResponse {
        invoices: types.SupplierInvoiceResponse[]
    }

    export interface GetEvalInvoicesResponse {
        invoice: types.SupplierInvoiceResponse
    }

    export interface GetEvaluationResultsResponse {
        results: EvaluationResultResponseItem[]
    }

    export interface GetFortnoxInvoicesResponse {
        success: boolean
        invoices: lib.FortnoxInvoice[]
    }

    export interface GetFullInvoiceDataResponse {
        invoice: types.SupplierInvoiceResponse
    }

    export interface GetGoldenInvoiceDatasetResponse {
        dataSet: RawGoldenInvoice[]
    }

    export interface GetInvoiceStatusResponse {
        status: client.InvoiceAnalysisStatus
    }

    export interface GetInvoicesResponse {
        invoices: types.SupplierInvoiceResponse[]
    }

    export interface ProcessInvoiceRequest {
        invoiceId: string
        apiKey: string
    }

    export interface ProcessedPerDayItem {
        date: string
        count: number
    }

    export interface ProcessedPerDayResponse {
        data: ProcessedPerDayItem[]
    }

    export interface RawGoldenInvoice {
        id: number
        name: string
        fileName?: string
        fileUrl?: string
        invoiceNumber: string
        direction: string
        amount: number
        totalAmount: number
        vatAmount: number
        currency: string
        invoiceDate: string
        dueDate: string
        supplier: RawSupplier
        invoiceLineItems: RawInvoiceLineItem[]
    }

    export interface RawInvoiceLineItem {
        id: number
        description: string
        quantity: number
        unit: string
        exVatAmount: number
        vatRate: number
        vatAmount: number
        totalAmount: number
        currency: string
        accountClassNumber?: string
        accountNumber?: string
    }

    export interface RawSupplier {
        companyName?: string | null
        companyOrganizationNumber?: string | null
        companyVatNumber?: string | null
        companyStreetAddress?: string | null
        companyZipCode?: string | null
        companyCity?: string | null
        companyCountry?: string | null
        companyPhone?: string | null
        companyEmail?: string | null
    }

    export interface RunEvalRequest {
        invoiceFileName: string
        apiKey: string
    }

    export interface SanityCheckInvoiceRequest {
        invoiceId: string
        apiKey: string
    }

    export interface SanityCheckInvoiceResponse {
        success: boolean
    }

    export interface TriggerEvaluationAnalysisRequest {
        processingVersionTag?: string
    }

    export interface UpdateLineItemRequest {
        accountClassNumber?: string
        accountNumber?: string
    }

    export interface UpdateLineItemResponse {
        success: boolean
    }

    export interface UploadEvalInvoiceRequest {
        fileName: string
        base64File: string
        orgSlug: string
        apiKey: string
        isEvaluationInvoice: boolean
        goldenInvoiceFileName: string
    }

    export interface UploadEvalInvoiceResponse {
        id: string
        fileName: string | null
    }

    export interface UploadInvoiceFileRequest {
        fileName: string
        base64File: string
        orgSlug: string
        isEvaluationInvoice?: boolean
        goldenInvoiceFileName?: string
    }
}

export namespace types {
    export interface Account {
        id: string
        organizationId: string
        accountNumber: string
        name: string
        description: string | null
        accountClassId: string
        parentId: string | null
        isActive: boolean
        isSystemAccount: boolean
        isBankAccount: boolean
        allowManualJournal: boolean
        defaultVatCode: string | null
        defaultVatRate: number | null
        createdAt: string
        updatedAt: string
    }

    export interface AccountClass {
        id: string
        code: string
        name: string
        accountType: AccountType
        normalBalance: NormalBalance
    }

    export type AccountType = "ASSET" | "LIABILITY" | "EQUITY" | "REVENUE" | "EXPENSE"

    export interface AccountWithClass {
        accountClass: AccountClass
        id: string
        organizationId: string
        accountNumber: string
        name: string
        description: string | null
        accountClassId: string
        parentId: string | null
        isActive: boolean
        isSystemAccount: boolean
        isBankAccount: boolean
        allowManualJournal: boolean
        defaultVatCode: string | null
        defaultVatRate: number | null
        createdAt: string
        updatedAt: string
    }

    export interface AccountWithHierarchy {
        parent: Account | null
        children: Account[]
        accountClass: AccountClass
        id: string
        organizationId: string
        accountNumber: string
        name: string
        description: string | null
        accountClassId: string
        parentId: string | null
        isActive: boolean
        isSystemAccount: boolean
        isBankAccount: boolean
        allowManualJournal: boolean
        defaultVatCode: string | null
        defaultVatRate: number | null
        createdAt: string
        updatedAt: string
    }

    export interface AccountingPeriod {
        id: string
        fiscalYearId: string
        periodNumber: number
        name: string
        startDate: string
        endDate: string
        status: AccountingPeriodStatus
        createdAt: string
        updatedAt: string
    }

    export type AccountingPeriodStatus = "OPEN" | "CLOSED" | "LOCKED"

    export type ChartVersion = "BAS-2025" | "BAS-2026" | "BAS-2025" | "BAS-2026"

    export interface CreateAccountPayload {
        organizationId: string
        accountNumber: string
        name: string
        description?: string
        accountClassId: string
        parentId?: string
        isActive?: boolean
        isBankAccount?: boolean
        allowManualJournal?: boolean
        defaultVatCode?: string
        defaultVatRate?: number
    }

    export interface CreateAccountingPeriodPayload {
        fiscalYearId: string
        periodNumber: number
        name: string
        startDate: string
        endDate: string
    }

    export interface CreateFiscalYearPayload {
        organizationId: string
        name: string
        startDate: string
        endDate: string
    }

    export interface FiscalYear {
        id: string
        organizationId: string
        name: string
        startDate: string
        endDate: string
        status: FiscalYearStatus
        createdAt: string
        updatedAt: string
    }

    export type FiscalYearStatus = "OPEN" | "CLOSED" | "LOCKED"

    export interface FullSupplierInvoiceResponse {
        id: string
        description?: string | null
        externalId?: string | null
        isExternal?: boolean | null
        createdAt: string | string
        updatedAt: string | string
        invoiceNumber?: string | null
        direction?: string | null
        amount?: string | null
        totalAmount?: string | null
        vatAmount?: string | null
        roundingAmount?: string | null
        currency?: string | null
        invoiceDate?: string | string | null
        dueDate?: string | string | null
        paymentReference?: string | null
        ourReferenceName?: string | null
        ourReferenceEmail?: string | null
        ourReferencePhone?: string | null
        theirReferenceName?: string | null
        theirReferenceEmail?: string | null
        theirReferencePhone?: string | null
        status?: string | null
        fileUrl?: string | null
        fileName?: string | null
        base64File?: string | null
        webhookUrl?: string | null
        webhookCallStatus?: string | null
        analysisStatus?: client.InvoiceAnalysisStatus
        analysisErrorMessage?: string | null
        supplierId?: string | null
        supplier?: Supplier | null
        lineItems?: SupplierInvoiceLineItem[]
    }

    export interface InvoiceData {
        id: string
        invoiceNumber?: string
        description?: string
        totalAmount?: string
        vatAmount?: string
        currency?: string
        invoiceDate?: string
        dueDate?: string
        supplier?: SupplierData
        lineItems?: LineItemData[]
        status?: string
        createdAt: string
    }

    export interface InvoicesQueryParams {
        limit?: number
        offset?: number
        dateFrom?: string
        dateTo?: string
        supplierId?: string
        status?: string
        search?: string
    }

    export interface LineItemData {
        id: string
        description?: string
        quantity?: number
        unit?: string
        exVatAmount?: string
        vatAmount?: string
        vatRate?: string
        totalAmount?: string
        accountNumber?: string
        accountClassNumber?: string
    }

    export interface ListAccountsPayload {
        isActive?: boolean
        accountClassId?: string
        parentId?: string | null
        includeHierarchy?: boolean
    }

    export interface ListSupplierInvoicesParams {
        limit?: number
        page?: number
        status?: client.InvoiceAnalysisStatus | string
        externalId?: string
        fileName?: string
        createdDateFrom?: string
        createdDateTo?: string
        updatedDateFrom?: string
        updatedDateTo?: string
        sortBy?: "createdAt" | "updatedAt" | "invoiceDate" | "fileName"
        sortOrder?: "asc" | "desc"
    }

    export interface ListSupplierInvoicesResponse {
        data: SupplierInvoiceItem[]
        meta: {
            totalItems: number
            itemsPerPage: number
            currentPage: number
            totalPages: number
        }
    }

    export type NormalBalance = "DEBIT" | "CREDIT"

    export interface PublicInvoiceCreateResponse {
        externalId: string
        status: string
    }

    export interface PublicSupplierInvoiceCreateRequest {
        fileName: string
        base64File: string
        contentType: string
        webhookUrl: string
        externalId: string
    }

    export interface SeedAccountsPayload {
        country?: SupportedCountry
        chartVersion: ChartVersion
        year?: SupportedYear
    }

    export interface SeedAccountsResponse {
        accountsCreated: number
    }

    export interface SpendingAnalytics {
        totalSpending: string
        averageInvoiceAmount: string
        invoiceCount: number
        currency: string
        periodStart?: string
        periodEnd?: string
        bySupplier?: {
            supplier: SupplierData
            totalAmount: string
            invoiceCount: number
        }[]
        byMonth?: {
            month: string
            year: number
            totalAmount: string
            invoiceCount: number
        }[]
    }

    export interface Supplier {
        id: string
        createdAt: string | string
        updatedAt: string | string
        storeName?: string | null
        storeStreetAddress?: string | null
        storeZipCode?: string | null
        storeCity?: string | null
        storeCountry?: string | null
        storePhone?: string | null
        storeEmail?: string | null
        storeVatNumber?: string | null
        storeOrganizationNumber?: string | null
        companyName?: string | null
        companyStreetAddress?: string | null
        companyZipCode?: string | null
        companyCity?: string | null
        companyCountry?: string | null
        companyPhone?: string | null
        companyEmail?: string | null
        companyVatNumber?: string | null
        companyOrganizationNumber?: string | null
    }

    export interface SupplierData {
        id: string
        companyName?: string
        organizationNumber?: string
        vatNumber?: string
        email?: string
        phone?: string
        streetAddress?: string
        city?: string
        zipCode?: string
        country?: string
    }

    export interface SupplierInvoiceItem {
        id: string
        externalId?: string | null
        fileName: string | null
        analysisStatus: client.InvoiceAnalysisStatus
        invoiceDate?: string | null
        totalAmount?: string | null
        currency?: string | null
        createdAt: string
        updatedAt: string
        webhookUrl: string | null
        webhookCallStatus?: string | null
    }

    export interface SupplierInvoiceLineItem {
        id: string
        invoiceId: string
        productId?: string | null
        description?: string | null
        exVatAmount?: string | null
        vatAmount?: string | null
        vatRate?: string | null
        totalAmount?: string | null
        currency?: string | null
        quantity?: string | null
        unit?: string | null
        accountClassNumber?: string | null
        accountNumber?: string | null
    }

    export interface SupplierInvoiceResponse {
        id: string
        description?: string | null
        externalId?: string | null
        isExternal?: boolean | null
        createdAt: string | string
        updatedAt: string | string
        invoiceNumber?: string | null
        direction?: string | null
        amount?: string | null
        totalAmount?: string | null
        vatAmount?: string | null
        roundingAmount?: string | null
        currency?: string | null
        invoiceDate?: string | string | null
        dueDate?: string | string | null
        paymentReference?: string | null
        ourReferenceName?: string | null
        ourReferenceEmail?: string | null
        ourReferencePhone?: string | null
        theirReferenceName?: string | null
        theirReferenceEmail?: string | null
        theirReferencePhone?: string | null
        status?: string | null
        fileUrl?: string | null
        fileName?: string | null
        base64File?: string | null
        webhookUrl?: string | null
        webhookCallStatus?: string | null
        analysisStatus?: client.InvoiceAnalysisStatus
        analysisErrorMessage?: string | null
        rawAnalysisData?: any
        supplierId?: string | null
        supplier?: Supplier | null
        lineItems?: SupplierInvoiceLineItem[]
        isEvaluationInvoice?: boolean | null
        goldenInvoiceFileName?: string | null
    }

    export interface SupplierInvoiceStatusResponse {
        externalId: string
        isExternal: boolean
        status: client.InvoiceAnalysisStatus
        updatedAt: string
        webhookCallStatus?: string | null
    }

    export type SupportedCountry = "SE" | "DK"

    export type SupportedYear = 2025 | 2026

    export interface UpdateInvoiceLineItemRequest {
        id: string
        accountClassNumber?: string | null
        accountNumber?: string | null
        exVatAmount?: string | null
        vatAmount?: string | null
        totalAmount?: string | null
    }
}



function encodeQuery(parts: Record<string, string | string[]>): string {
    const pairs: string[] = []
    for (const key in parts) {
        const val = (Array.isArray(parts[key]) ?  parts[key] : [parts[key]]) as string[]
        for (const v of val) {
            pairs.push(`${key}=${encodeURIComponent(v)}`)
        }
    }
    return pairs.join("&")
}

// makeRecord takes a record and strips any undefined values from it,
// and returns the same record with a narrower type.
// @ts-ignore - TS ignore because makeRecord is not always used
function makeRecord<K extends string | number | symbol, V>(record: Record<K, V | undefined>): Record<K, V> {
    for (const key in record) {
        if (record[key] === undefined) {
            delete record[key]
        }
    }
    return record as Record<K, V>
}

function encodeWebSocketHeaders(headers: Record<string, string>) {
    // url safe, no pad
    const base64encoded = btoa(JSON.stringify(headers))
      .replaceAll("=", "")
      .replaceAll("+", "-")
      .replaceAll("/", "_");
    return "encore.dev.headers." + base64encoded;
}

class WebSocketConnection {
    public ws: WebSocket;

    private hasUpdateHandlers: (() => void)[] = [];

    constructor(url: string, headers?: Record<string, string>) {
        let protocols = ["encore-ws"];
        if (headers) {
            protocols.push(encodeWebSocketHeaders(headers))
        }

        this.ws = new WebSocket(url, protocols)

        this.on("error", () => {
            this.resolveHasUpdateHandlers();
        });

        this.on("close", () => {
            this.resolveHasUpdateHandlers();
        });
    }

    resolveHasUpdateHandlers() {
        const handlers = this.hasUpdateHandlers;
        this.hasUpdateHandlers = [];

        for (const handler of handlers) {
            handler()
        }
    }

    async hasUpdate() {
        // await until a new message have been received, or the socket is closed
        await new Promise((resolve) => {
            this.hasUpdateHandlers.push(() => resolve(null))
        });
    }

    on(type: "error" | "close" | "message" | "open", handler: (event: any) => void) {
        this.ws.addEventListener(type, handler);
    }

    off(type: "error" | "close" | "message" | "open", handler: (event: any) => void) {
        this.ws.removeEventListener(type, handler);
    }

    close() {
        this.ws.close();
    }
}

export class StreamInOut<Request, Response> {
    public socket: WebSocketConnection;
    private buffer: Response[] = [];

    constructor(url: string, headers?: Record<string, string>) {
        this.socket = new WebSocketConnection(url, headers);
        this.socket.on("message", (event: any) => {
            this.buffer.push(JSON.parse(event.data));
            this.socket.resolveHasUpdateHandlers();
        });
    }

    close() {
        this.socket.close();
    }

    async send(msg: Request) {
        if (this.socket.ws.readyState === WebSocket.CONNECTING) {
            // await that the socket is opened
            await new Promise((resolve) => {
                this.socket.ws.addEventListener("open", resolve, { once: true });
            });
        }

        return this.socket.ws.send(JSON.stringify(msg));
    }

    async next(): Promise<Response | undefined> {
        for await (const next of this) return next;
        return undefined;
    }

    async *[Symbol.asyncIterator](): AsyncGenerator<Response, undefined, void> {
        while (true) {
            if (this.buffer.length > 0) {
                yield this.buffer.shift() as Response;
            } else {
                if (this.socket.ws.readyState === WebSocket.CLOSED) return;
                await this.socket.hasUpdate();
            }
        }
    }
}

export class StreamIn<Response> {
    public socket: WebSocketConnection;
    private buffer: Response[] = [];

    constructor(url: string, headers?: Record<string, string>) {
        this.socket = new WebSocketConnection(url, headers);
        this.socket.on("message", (event: any) => {
            this.buffer.push(JSON.parse(event.data));
            this.socket.resolveHasUpdateHandlers();
        });
    }

    close() {
        this.socket.close();
    }

    async next(): Promise<Response | undefined> {
        for await (const next of this) return next;
        return undefined;
    }

    async *[Symbol.asyncIterator](): AsyncGenerator<Response, undefined, void> {
        while (true) {
            if (this.buffer.length > 0) {
                yield this.buffer.shift() as Response;
            } else {
                if (this.socket.ws.readyState === WebSocket.CLOSED) return;
                await this.socket.hasUpdate();
            }
        }
    }
}

export class StreamOut<Request, Response> {
    public socket: WebSocketConnection;
    private responseValue: Promise<Response>;

    constructor(url: string, headers?: Record<string, string>) {
        let responseResolver: (_: any) => void;
        this.responseValue = new Promise((resolve) => responseResolver = resolve);

        this.socket = new WebSocketConnection(url, headers);
        this.socket.on("message", (event: any) => {
            responseResolver(JSON.parse(event.data))
        });
    }

    async response(): Promise<Response> {
        return this.responseValue;
    }

    close() {
        this.socket.close();
    }

    async send(msg: Request) {
        if (this.socket.ws.readyState === WebSocket.CONNECTING) {
            // await that the socket is opened
            await new Promise((resolve) => {
                this.socket.ws.addEventListener("open", resolve, { once: true });
            });
        }

        return this.socket.ws.send(JSON.stringify(msg));
    }
}
// CallParameters is the type of the parameters to a method call, but require headers to be a Record type
type CallParameters = Omit<RequestInit, "method" | "body" | "headers"> & {
    /** Headers to be sent with the request */
    headers?: Record<string, string>

    /** Query parameters to be sent with the request */
    query?: Record<string, string | string[]>
}

// AuthDataGenerator is a function that returns a new instance of the authentication data required by this API
export type AuthDataGenerator = () =>
  | api_gateway.AuthParams
  | Promise<api_gateway.AuthParams | undefined>
  | undefined;

// A fetcher is the prototype for the inbuilt Fetch function
export type Fetcher = typeof fetch;

const boundFetch = fetch.bind(this);

class BaseClient {
    readonly baseURL: string
    readonly fetcher: Fetcher
    readonly headers: Record<string, string>
    readonly requestInit: Omit<RequestInit, "headers"> & { headers?: Record<string, string> }
    readonly authGenerator?: AuthDataGenerator

    constructor(baseURL: string, options: ClientOptions) {
        this.baseURL = baseURL
        this.headers = {}

        // Add User-Agent header if the script is running in the server
        // because browsers do not allow setting User-Agent headers to requests
        if (!BROWSER) {
            this.headers["User-Agent"] = "ledgentic-backend-bvdi-Generated-TS-Client (Encore/v1.48.12)";
        }

        this.requestInit = options.requestInit ?? {};

        // Setup what fetch function we'll be using in the base client
        if (options.fetcher !== undefined) {
            this.fetcher = options.fetcher
        } else {
            this.fetcher = boundFetch
        }

        // Setup an authentication data generator using the auth data token option
        if (options.auth !== undefined) {
            const auth = options.auth
            if (typeof auth === "function") {
                this.authGenerator = auth
            } else {
                this.authGenerator = () => auth
            }
        }
    }

    async getAuthData(): Promise<CallParameters | undefined> {
        let authData: api_gateway.AuthParams | undefined;

        // If authorization data generator is present, call it and add the returned data to the request
        if (this.authGenerator) {
            const mayBePromise = this.authGenerator();
            if (mayBePromise instanceof Promise) {
                authData = await mayBePromise;
            } else {
                authData = mayBePromise;
            }
        }

        if (authData) {
            const data: CallParameters = {};

            data.headers = makeRecord<string, string>({
                cookie:      authData.cookie,
                "x-api-key": authData.apiKey,
            });

            return data;
        }

        return undefined;
    }

    // createStreamInOut sets up a stream to a streaming API endpoint.
    async createStreamInOut<Request, Response>(path: string, params?: CallParameters): Promise<StreamInOut<Request, Response>> {
        let { query, headers } = params ?? {};

        // Fetch auth data if there is any
        const authData = await this.getAuthData();

        // If we now have authentication data, add it to the request
        if (authData) {
            if (authData.query) {
                query = {...query, ...authData.query};
            }
            if (authData.headers) {
                headers = {...headers, ...authData.headers};
            }
        }

        const queryString = query ? '?' + encodeQuery(query) : ''
        return new StreamInOut(this.baseURL + path + queryString, headers);
    }

    // createStreamIn sets up a stream to a streaming API endpoint.
    async createStreamIn<Response>(path: string, params?: CallParameters): Promise<StreamIn<Response>> {
        let { query, headers } = params ?? {};

        // Fetch auth data if there is any
        const authData = await this.getAuthData();

        // If we now have authentication data, add it to the request
        if (authData) {
            if (authData.query) {
                query = {...query, ...authData.query};
            }
            if (authData.headers) {
                headers = {...headers, ...authData.headers};
            }
        }

        const queryString = query ? '?' + encodeQuery(query) : ''
        return new StreamIn(this.baseURL + path + queryString, headers);
    }

    // createStreamOut sets up a stream to a streaming API endpoint.
    async createStreamOut<Request, Response>(path: string, params?: CallParameters): Promise<StreamOut<Request, Response>> {
        let { query, headers } = params ?? {};

        // Fetch auth data if there is any
        const authData = await this.getAuthData();

        // If we now have authentication data, add it to the request
        if (authData) {
            if (authData.query) {
                query = {...query, ...authData.query};
            }
            if (authData.headers) {
                headers = {...headers, ...authData.headers};
            }
        }

        const queryString = query ? '?' + encodeQuery(query) : ''
        return new StreamOut(this.baseURL + path + queryString, headers);
    }

    // callTypedAPI makes an API call, defaulting content type to "application/json"
    public async callTypedAPI(method: string, path: string, body?: RequestInit["body"], params?: CallParameters): Promise<Response> {
        return this.callAPI(method, path, body, {
            ...params,
            headers: { "Content-Type": "application/json", ...params?.headers }
        });
    }

    // callAPI is used by each generated API method to actually make the request
    public async callAPI(method: string, path: string, body?: RequestInit["body"], params?: CallParameters): Promise<Response> {
        let { query, headers, ...rest } = params ?? {}
        const init = {
            ...this.requestInit,
            ...rest,
            method,
            body: body ?? null,
        }

        // Merge our headers with any predefined headers
        init.headers = {...this.headers, ...init.headers, ...headers}

        // Fetch auth data if there is any
        const authData = await this.getAuthData();

        // If we now have authentication data, add it to the request
        if (authData) {
            if (authData.query) {
                query = {...query, ...authData.query};
            }
            if (authData.headers) {
                init.headers = {...init.headers, ...authData.headers};
            }
        }

        // Make the actual request
        const queryString = query ? '?' + encodeQuery(query) : ''
        const response = await this.fetcher(this.baseURL+path+queryString, init)

        // handle any error responses
        if (!response.ok) {
            // try and get the error message from the response body
            let body: APIErrorResponse = { code: ErrCode.Unknown, message: `request failed: status ${response.status}` }

            // if we can get the structured error we should, otherwise give a best effort
            try {
                const text = await response.text()

                try {
                    const jsonBody = JSON.parse(text)
                    if (isAPIErrorResponse(jsonBody)) {
                        body = jsonBody
                    } else {
                        body.message += ": " + JSON.stringify(jsonBody)
                    }
                } catch {
                    body.message += ": " + text
                }
            } catch (e) {
                // otherwise we just append the text to the error message
                body.message += ": " + String(e)
            }

            throw new APIError(response.status, body)
        }

        return response
    }
}

/**
 * APIErrorDetails represents the response from an Encore API in the case of an error
 */
interface APIErrorResponse {
    code: ErrCode
    message: string
    details?: any
}

function isAPIErrorResponse(err: any): err is APIErrorResponse {
    return (
        err !== undefined && err !== null &&
        isErrCode(err.code) &&
        typeof(err.message) === "string" &&
        (err.details === undefined || err.details === null || typeof(err.details) === "object")
    )
}

function isErrCode(code: any): code is ErrCode {
    return code !== undefined && Object.values(ErrCode).includes(code)
}

/**
 * APIError represents a structured error as returned from an Encore application.
 */
export class APIError extends Error {
    /**
     * The HTTP status code associated with the error.
     */
    public readonly status: number

    /**
     * The Encore error code
     */
    public readonly code: ErrCode

    /**
     * The error details
     */
    public readonly details?: any

    constructor(status: number, response: APIErrorResponse) {
        // extending errors causes issues after you construct them, unless you apply the following fixes
        super(response.message);

        // set error name as constructor name, make it not enumerable to keep native Error behavior
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/new.target#new.target_in_constructors
        Object.defineProperty(this, 'name', {
            value:        'APIError',
            enumerable:   false,
            configurable: true,
        })

        // fix the prototype chain
        if ((Object as any).setPrototypeOf == undefined) {
            (this as any).__proto__ = APIError.prototype
        } else {
            Object.setPrototypeOf(this, APIError.prototype);
        }

        // capture a stack trace
        if ((Error as any).captureStackTrace !== undefined) {
            (Error as any).captureStackTrace(this, this.constructor);
        }

        this.status = status
        this.code = response.code
        this.details = response.details
    }
}

/**
 * Typeguard allowing use of an APIError's fields'
 */
export function isAPIError(err: any): err is APIError {
    return err instanceof APIError;
}

export enum ErrCode {
    /**
     * OK indicates the operation was successful.
     */
    OK = "ok",

    /**
     * Canceled indicates the operation was canceled (typically by the caller).
     *
     * Encore will generate this error code when cancellation is requested.
     */
    Canceled = "canceled",

    /**
     * Unknown error. An example of where this error may be returned is
     * if a Status value received from another address space belongs to
     * an error-space that is not known in this address space. Also
     * errors raised by APIs that do not return enough error information
     * may be converted to this error.
     *
     * Encore will generate this error code in the above two mentioned cases.
     */
    Unknown = "unknown",

    /**
     * InvalidArgument indicates client specified an invalid argument.
     * Note that this differs from FailedPrecondition. It indicates arguments
     * that are problematic regardless of the state of the system
     * (e.g., a malformed file name).
     *
     * This error code will not be generated by the gRPC framework.
     */
    InvalidArgument = "invalid_argument",

    /**
     * DeadlineExceeded means operation expired before completion.
     * For operations that change the state of the system, this error may be
     * returned even if the operation has completed successfully. For
     * example, a successful response from a server could have been delayed
     * long enough for the deadline to expire.
     *
     * The gRPC framework will generate this error code when the deadline is
     * exceeded.
     */
    DeadlineExceeded = "deadline_exceeded",

    /**
     * NotFound means some requested entity (e.g., file or directory) was
     * not found.
     *
     * This error code will not be generated by the gRPC framework.
     */
    NotFound = "not_found",

    /**
     * AlreadyExists means an attempt to create an entity failed because one
     * already exists.
     *
     * This error code will not be generated by the gRPC framework.
     */
    AlreadyExists = "already_exists",

    /**
     * PermissionDenied indicates the caller does not have permission to
     * execute the specified operation. It must not be used for rejections
     * caused by exhausting some resource (use ResourceExhausted
     * instead for those errors). It must not be
     * used if the caller cannot be identified (use Unauthenticated
     * instead for those errors).
     *
     * This error code will not be generated by the gRPC core framework,
     * but expect authentication middleware to use it.
     */
    PermissionDenied = "permission_denied",

    /**
     * ResourceExhausted indicates some resource has been exhausted, perhaps
     * a per-user quota, or perhaps the entire file system is out of space.
     *
     * This error code will be generated by the gRPC framework in
     * out-of-memory and server overload situations, or when a message is
     * larger than the configured maximum size.
     */
    ResourceExhausted = "resource_exhausted",

    /**
     * FailedPrecondition indicates operation was rejected because the
     * system is not in a state required for the operation's execution.
     * For example, directory to be deleted may be non-empty, an rmdir
     * operation is applied to a non-directory, etc.
     *
     * A litmus test that may help a service implementor in deciding
     * between FailedPrecondition, Aborted, and Unavailable:
     *  (a) Use Unavailable if the client can retry just the failing call.
     *  (b) Use Aborted if the client should retry at a higher-level
     *      (e.g., restarting a read-modify-write sequence).
     *  (c) Use FailedPrecondition if the client should not retry until
     *      the system state has been explicitly fixed. E.g., if an "rmdir"
     *      fails because the directory is non-empty, FailedPrecondition
     *      should be returned since the client should not retry unless
     *      they have first fixed up the directory by deleting files from it.
     *  (d) Use FailedPrecondition if the client performs conditional
     *      REST Get/Update/Delete on a resource and the resource on the
     *      server does not match the condition. E.g., conflicting
     *      read-modify-write on the same resource.
     *
     * This error code will not be generated by the gRPC framework.
     */
    FailedPrecondition = "failed_precondition",

    /**
     * Aborted indicates the operation was aborted, typically due to a
     * concurrency issue like sequencer check failures, transaction aborts,
     * etc.
     *
     * See litmus test above for deciding between FailedPrecondition,
     * Aborted, and Unavailable.
     */
    Aborted = "aborted",

    /**
     * OutOfRange means operation was attempted past the valid range.
     * E.g., seeking or reading past end of file.
     *
     * Unlike InvalidArgument, this error indicates a problem that may
     * be fixed if the system state changes. For example, a 32-bit file
     * system will generate InvalidArgument if asked to read at an
     * offset that is not in the range [0,2^32-1], but it will generate
     * OutOfRange if asked to read from an offset past the current
     * file size.
     *
     * There is a fair bit of overlap between FailedPrecondition and
     * OutOfRange. We recommend using OutOfRange (the more specific
     * error) when it applies so that callers who are iterating through
     * a space can easily look for an OutOfRange error to detect when
     * they are done.
     *
     * This error code will not be generated by the gRPC framework.
     */
    OutOfRange = "out_of_range",

    /**
     * Unimplemented indicates operation is not implemented or not
     * supported/enabled in this service.
     *
     * This error code will be generated by the gRPC framework. Most
     * commonly, you will see this error code when a method implementation
     * is missing on the server. It can also be generated for unknown
     * compression algorithms or a disagreement as to whether an RPC should
     * be streaming.
     */
    Unimplemented = "unimplemented",

    /**
     * Internal errors. Means some invariants expected by underlying
     * system has been broken. If you see one of these errors,
     * something is very broken.
     *
     * This error code will be generated by the gRPC framework in several
     * internal error conditions.
     */
    Internal = "internal",

    /**
     * Unavailable indicates the service is currently unavailable.
     * This is a most likely a transient condition and may be corrected
     * by retrying with a backoff. Note that it is not always safe to retry
     * non-idempotent operations.
     *
     * See litmus test above for deciding between FailedPrecondition,
     * Aborted, and Unavailable.
     *
     * This error code will be generated by the gRPC framework during
     * abrupt shutdown of a server process or network connection.
     */
    Unavailable = "unavailable",

    /**
     * DataLoss indicates unrecoverable data loss or corruption.
     *
     * This error code will not be generated by the gRPC framework.
     */
    DataLoss = "data_loss",

    /**
     * Unauthenticated indicates the request does not have valid
     * authentication credentials for the operation.
     *
     * The gRPC framework will generate this error code when the
     * authentication metadata is invalid or a Credentials callback fails,
     * but also expect authentication middleware to generate it.
     */
    Unauthenticated = "unauthenticated",
}
